import { render, staticRenderFns } from "./UserManualDetails.vue?vue&type=template&id=02b8337f&scoped=true&"
import script from "./UserManualDetails.vue?vue&type=script&lang=js&"
export * from "./UserManualDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b8337f",
  null
  
)

export default component.exports